import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../common';
import {
  AddressItemCreate,
  AddressItemDelete,
  AddressItemInitialState,
  AddressItemLoad,
  AddressItemUpdate,
} from './address-item.actions';
import { AddressItemState, AddressItemStateModel } from './address-item.state';
import { AddressRequestModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class AddressItemFacade implements LoadDataFacade, SetInitialStateFacade {
  addressData$: Observable<AddressItemStateModel> = this.store.select(AddressItemState.getState);
  addressId$: Observable<number> = this.store.select(AddressItemState.getAddressId);
  addressName$: Observable<string> = this.store.select(AddressItemState.getAddressName);
  loaded$: Observable<boolean> = this.store.select(AddressItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(addressId: string): void {
    this.store.dispatch(new AddressItemLoad(addressId));
  }

  createAddress(data: AddressRequestModel): void {
    this.store.dispatch(new AddressItemCreate(data));
  }

  updateAddress(data: AddressRequestModel): void {
    this.store.dispatch(new AddressItemUpdate(data));
  }

  deleteAddress(addressId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new AddressItemDelete({ dialog, addressId }));
  }

  setInitialState(): void {
    this.store.dispatch(new AddressItemInitialState());
  }
}
